import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/components/utils";

import { string, node, oneOf } from "prop-types";
import { Info, TriangleAlert, Check } from "lucide-react";

const alertVariants = cva(
  "w-full rounded-lg border p-4 flex gap-2 justify-between",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive:
          "border-destructive dark:border-destructive [&>svg]:text-destructive",
        success: "border-success dark:border-success [&>svg]:text-success",
        warning:
          "border-warning/10 bg-warning/10 dark:border-warning [&>svg]:text-warning",
        ghost: "border-none",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Alert = ({ className, icon, title, message, variant, slot }) => {
  let _icon = <Info />;

  if (icon) {
    _icon = icon;
  } else if (variant === "destructive") {
    _icon = <TriangleAlert className="text-destructive!" />;
  } else if (variant === "warning") {
    _icon = <TriangleAlert className="text-warning!" />;
  } else if (variant === "success") {
    _icon = <Check className="text-success!" />;
  }

  return (
    <div className={cn(alertVariants({ variant }), className)}>
      <div className="w-[24px]">{_icon}</div>
      <div className="flex flex-1 flex-col justify-center">
        {title && <div className="font-bold">{title}</div>}
        <div>{message}</div>
      </div>
      <div>{slot}</div>
    </div>
  );
};

Alert.propTypes = {
  className: string,
  icon: node,
  title: node,
  message: node.isRequired,
  variant: oneOf(["default", "warning", "destructive"]),
  slot: node,
};

Alert.defaultProps = {
  variant: "default",
};

export default Alert;
